import Image from "next/image";
import { useEffect, useState } from "react";

interface ImageGalleryProps {
  coverImage: string;
  otherImages?: string[];
}

function ImageGallery(props: ImageGalleryProps) {
  const joinedImagesArray: string[] = [props.coverImage, ...(props.otherImages ? props.otherImages : [])];

  const [currentPictureIndex, setCurrentPictureIndex] = useState<number>(0);
  const [currentPictureUrl, setCurrentPictureUrl] = useState<string>(joinedImagesArray[0]);

  useEffect(() => {
    setCurrentPictureUrl(joinedImagesArray[currentPictureIndex]);
  }, [currentPictureIndex]);

  return (
    <div className="overflow-hidden flex flex-col items-start gap-2.5 flex-auto">
      <div className="rounded-4xl relative overflow-hidden w-full h-full w-max-[1200px] h-max-[1200px] aspect-square" >
        <div className="w-full h-full w-max-full h-max-full overflow-hidden">
          <Image src={currentPictureUrl} alt={`Product picture ${currentPictureIndex + 1}`} width={1200} height={1200} className="rounded-4xl object-contain w-full h-full" />
        </div>
      </div>
      <div className="overflow-hidden flex flex-col items-start gap-2.5">
        {joinedImagesArray.map((imgUrl, imgIndex) => (
          <div key={`image-thumbnail-${imgIndex}`} className={"rounded-lg relative max-h-[80px] overflow-hidden aspect-square" + (imgIndex == currentPictureIndex ? " border-secondary border-2" : "")}>
            <div className="w-full h-full">
              <Image
                src={imgUrl}
                alt={`Product picture ${imgIndex + 1}`}
                className={"rounded-lg object-contain w-full h-full"}
                width={80}
                height={80}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ImageGallery;
